import { render, staticRenderFns } from "./MediumText.vue?vue&type=template&id=2a11913c&scoped=true"
import script from "./MediumText.vue?vue&type=script&lang=js"
export * from "./MediumText.vue?vue&type=script&lang=js"
import style0 from "./MediumText.vue?vue&type=style&index=0&id=2a11913c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a11913c",
  null
  
)

export default component.exports